export function isHiddenFaultOwnershipType(item) {
  const rawValue = item?.FaultOwnershipType ?? item?.faultOwnershipType;
  return String(rawValue ?? '').trim() === '99';
}

export function excludeHiddenFaults(items) {
  return Array.isArray(items)
    ? items.filter((item) => !isHiddenFaultOwnershipType(item))
    : [];
}
